import { ProfessionalActionTypes } from "./actionTypes"

export const getProfessionals = (payload = {}) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_LIST_GET,
        payload: payload
    }
}

export const getProfessionalsSuccessful = (payload) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_LIST_GET_SUCCESSFUL,
        payload: payload
    }
}

export const getProfessionalsError = (payload) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_LIST_GET_ERROR,
        payload,
    }
}

export const setProfessionalQuery = (payload) => {
    return {
        type: ProfessionalActionTypes.SET_PROFESSIONAL_QUERY,
        payload,
    }
}

export const resetProfessionalQuery = () => {
    return {
        type: ProfessionalActionTypes.RESET_PROFESSIONAL_QUERY,
    }
}

export const removeProfessional = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_REMOVE,
        payload: professional
    }
}

export const removeProfessionalSuccess = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_REMOVE_SUCCESS,
        payload: professional
    }
}

export const removeProfessionalError = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_REMOVE_ERROR,
        payload: professional
    }
}

export const editProfessional = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_EDIT,
        payload: professional
    }
}

export const editProfessionalSuccess = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_EDIT_SUCCESS,
        payload: professional
    }
}

export const editProfessionalError = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_EDIT_ERROR,
        payload: professional
    }
}

export const updateProfessionalTranslations = (payload) => {
  return {
    type: ProfessionalActionTypes.PROFESSIONAL_TRANSLATION_EDIT,
    payload
  }
}

export const updateProfessionalTranslationsSuccess = (professional) => {
  console.log(professional)
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_TRANSLATION_EDIT_SUCCESS,
        payload: professional
    }
}

export const updateProfessionalTranslationsError = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_TRANSLATION_EDIT_ERROR,
        payload: professional
    }
}

export const approveProfessional = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_APPROVE,
        payload: professional
    }
}

export const approveProfessionalSuccess = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_EDIT_SUCCESS,
        payload: professional
    }
}

export const approveProfessionalError = (professional) => {
    return {
        type: ProfessionalActionTypes.PROFESSIONAL_EDIT_ERROR,
        payload: professional
    }
}
